/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */

import React, {useState} from "react";
import Modal from 'react-modal';


const FooterLink = ()=>{
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };


    return(
        <main>
            <div className="container-fluid px-4">
                <h1 className="mt-4">Dashboard</h1>
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active">Footer Links</li>
                </ol>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-6">
                                      <h4>Footer Links</h4>
                                    </div>
                                    <div className="col-6 text-end">
                                        <button  className={'btn btn-success btn-sm'}><i className="fas fa-plus-square text-white"/></button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <table className={'table table-bordered table-hover table-striped'}>
                                    <thead>
                                        <tr>
                                            <th>SL</th>
                                            <th>Name</th>
                                            <th>Link</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>Reality Show</td>
                                        <td>Reality Show</td>
                                        <td>
                                            <button className={'btn btn-warning btn-sm'}><i className={'fas fa-edit'}/> </button>
                                            <button className={'btn btn-danger btn-sm ms-1'}><i className={'fas fa-trash'}/> </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    )
}
export default FooterLink